/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Reviews_Empty_TitleInputs */

const he_account_reviews_empty_title = /** @type {(inputs: Account_Reviews_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אין ביקורות עדיין`)
};

const en_account_reviews_empty_title = /** @type {(inputs: Account_Reviews_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No reviews yet`)
};

/**
* | output |
* | --- |
* | "No reviews yet" |
*
* @param {Account_Reviews_Empty_TitleInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_reviews_empty_title = /** @type {((inputs?: Account_Reviews_Empty_TitleInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Reviews_Empty_TitleInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_reviews_empty_title(inputs)
	return en_account_reviews_empty_title(inputs)
});